export function createCddtiGroup(item: any, title: string): any {
  return {
    ...item,
    title,
    childrens: item.childrens.map(child => ({
      ...child,
      url: `${child.url}-cddti`
    }))
  };
}

/** Add separate CDDTI groups for the menus available to the current profile. */
export function withCddtiNavigation(menu: any[], hasAccess: boolean): any[] {
  const navigation = [];

  menu.forEach(item => {
    if (!item.childrens) {
      navigation.push({ ...item });
      return;
    }

    navigation.push({ ...item, childrens: item.childrens.map(child => ({ ...child })) });

    if (item.url === '/mes-ofa' && hasAccess === true) {
      navigation.push(createCddtiGroup(item, 'Mes OFA CDDTI'));
    }

    if (item.url === '/conseil-direction') {
      const childrens = item.childrens.filter(child =>
        child.url === '/propositions' || child.url === '/recap-solde'
      );

      if (childrens.length > 0) {
        navigation.push(createCddtiGroup({ ...item, childrens }, 'Conseil de direction CDDTI'));
      }
    }
  });

  return navigation;
}
